import { useMutation, useQueryClient } from "@tanstack/react-query";
import { permissionService } from "@/services/PermissionService";

export const permissionKeys = {
  all: ['permissions'],
  single: (id) => [...permissionKeys.all, id],
};

export const useCreatePermission = (options) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data) => permissionService.createPermission(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: permissionKeys.all });
    },
    ...options,
  });
};

export const useUpdatePermission = (options) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }) => permissionService.updatePermission(id, data),
    onSuccess: (_, { id }) => {
      queryClient.invalidateQueries({ queryKey: permissionKeys.single(id) });
      queryClient.invalidateQueries({ queryKey: permissionKeys.all });
    },
    ...options,
  });
};

export const useDeletePermission = (options) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id) => permissionService.deletePermission(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: permissionKeys.all });
    },
    ...options,
  });
}; 